"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushEvents = flushEvents;
const pinpoint_1 = require("@aws-amplify/core/internals/providers/pinpoint");
const utils_1 = require("@aws-amplify/core/internals/utils");
const core_1 = require("@aws-amplify/core");
const utils_2 = require("../utils");
const utils_3 = require("../../../utils");
const logger = new core_1.ConsoleLogger('Analytics');
function flushEvents(...args) {
    const [ctx] = (0, utils_1.resolveCtxArgs)(args);
    const { appId, region, bufferSize, flushSize, flushInterval, resendLimit } = (0, utils_2.resolveConfig)(ctx);
    (0, utils_2.resolveCredentials)(ctx)
        .then(({ credentials, identityId }) => {
        (0, pinpoint_1.flushEvents)({
            appId,
            region,
            credentials,
            identityId,
            bufferSize,
            flushSize,
            flushInterval,
            resendLimit,
            userAgentValue: (0, utils_3.getAnalyticsUserAgentString)(utils_1.AnalyticsAction.Record),
        });
    })
        .catch(e => {
        logger.warn('Failed to flush events', e);
    });
}
